import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const Wrapper = styled(Box)`
  @media (max-width: 767px) and (min-height: 600px) {
    height: calc(100vh - ${(props) => props.mobileHeaderHeight}px);
    .section-wrapper {
      height: calc(100vh - ${(props) => props.mobileHeaderHeight}px);
      display: flex;
      flex-direction: column;
    }
  }
`

export const TimelineItem = styled(Box)``

export const ProgressBar = styled.div`
  position: absolute;
  @media (max-width: 767px) {
    top: 0;
    bottom: 0;
    width: 2px;
    left: calc(50% - 1px);
    background-image: linear-gradient(
      to bottom,
      ${theme.wild.color.nova.transparency.black["60"]} 10%,
      rgba(255, 255, 255, 0) 20%
    );
    background-position: left;
    background-size: 2px 10px;
    background-repeat: repeat-y;

    &::before,
    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      height: 5%;
      z-index: 2;
    }

    &::before {
      top: 0;
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }

    &::after {
      bottom: 0;
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 100%
      );
    }
  }

  @media (min-width: 768px) {
    background-color: transparent;
    top: 13px;
    left: 0;
    right: 0;
    bottom: auto;
    height: 2px;
    width: 100%;
    background-position: top;
    background-repeat: repeat-x;
    background-size: 10px 2px;
    background-image: linear-gradient(
      to right,
      ${theme.wild.color.nova.transparency.black["60"]} 20%,
      rgba(255, 255, 255, 0) 10%
    );

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      width: 10%;
      z-index: 2;
      left: auto;
      right: auto;
    }

    &::before {
      left: 0;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }

    &::after {
      right: 0;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 100%
      );
    }
  }

  @media (max-width: 767px) and (max-height: 599px) {
    display: none;
  }
`

export const MobileProgress = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: ${theme.wild.color.nova.brand.accent["80"]};
  @media (min-width: 768px) {
    display: none;
  }
`

export const DesktopProgress = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: ${theme.wild.color.nova.brand.accent["80"]};
  @media (max-width: 767px) {
    display: none;
  }
`

export const Tag = styled(Box)`
  position: relative;
  display: inline-block;
  padding: 6px;
  border-radius: 2px;
  background: ${theme.wild.color.nova.base.solid["20"]};
  z-index: 3;

  .tag-text {
    position: relative;
    z-index: 2;
    line-height: 1;
    transform: translateY(1px);
  }

  @media (max-width: 767px) and (max-height: 599px) {
    background: ${theme.wild.color.nova.brand.accent["80"]} !important;
  }
`

export const CopyWrapper = styled(Box)`
  @media (max-width: 767px) {
    position: relative;
    z-index: 2;
    padding: 8px 0;
    margin: 24px auto 0;
    max-width: 280px;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 15%,
      rgba(255, 255, 255, 1) 85%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  @media (max-width: 767px) and (max-height: 599px) {
    margin: 8px auto 24px;
    .copy-wrapper-ref {
      opacity: 1 !important;
    }
  }
`
